import { useDispatch, useSelector } from "react-redux";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton, Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { useDownloadFromDigest } from "app/pages/benchmark-tracker/hooks/emailDigest/useDownloadFromDigest";
import { translate } from "app/filters/i18nFilter";
import { benchmarkTrackerTracking } from "app/pages/benchmark-tracker/services/tracking";
import { openSubscriptionModal } from "app/pages/benchmark-tracker/store/actions/report";
import { downloadPdfEffect } from "app/pages/benchmark-tracker/store/effects/menu";
import { selectSelectedBenchmark } from "app/pages/benchmark-tracker/store/selectors/entitySelectors";
import { selectIsDigestSubscribed, selectPdfIsLoading } from "app/pages/benchmark-tracker/store/selectors/reportSelectors";

import { DOWNLOAD_PDF, SUBSCRIPTIONS } from "./dataAutomationKeys";

type ReportActionsSchema = {
    isViewerMode: boolean;
};

export const ReportActions = ({ isViewerMode }: ReportActionsSchema) => {
    const selectedBenchmark = useSelector(selectSelectedBenchmark);
    const isDigestSubscribed = useSelector(selectIsDigestSubscribed);

    const dispatch = useDispatch();
    const isLoading = useSelector(selectPdfIsLoading);
    const track = benchmarkTrackerTracking.report;

    const onDownload = () => dispatch(downloadPdfEffect(selectedBenchmark?.primaryDomains?.join(", ")));

    useDownloadFromDigest(onDownload);

    const onAlertSettings = () => {
        dispatch(openSubscriptionModal());
        track.openSubscriptionModal(!isViewerMode);
    };

    return (
        <Flex alignItems="center" gap="4px">
            <IconButton
                iconName="download"
                type="flat"
                onClick={onDownload}
                isLoading={isLoading}
                dataAutomation={DOWNLOAD_PDF}
            >
                {translate("bt.report.download.pdf")}
            </IconButton>

            <Tooltip
                content={translate("bt.subscribe.action.tooltip.text")}
                enabled={isDigestSubscribed}
            >
                <div>
                    <IconButton
                        iconName={isDigestSubscribed ? "checked" : "email"}
                        iconColor={colorsPalettes.blue[400]}
                        iconSize={isDigestSubscribed ? "10px" : "xs"}
                        type="flat"
                        onClick={onAlertSettings}
                        dataAutomation={SUBSCRIPTIONS}
                    >
                        {translate(isDigestSubscribed ? "common.subscribed" : "bt.menu.subscribe")}
                    </IconButton>
                </div>
            </Tooltip>
        </Flex>
    );
};
